// initial state
const state = {
    state: "",
};

// getters
const getters = {
    // doneTodos: state => {
    //     return state.todos + 1
    // },
};

// actions
const actions = {
    // getAllProducts({ commit, state }, products) {
    //     commit('setProducts', products)
    // }
};

// mutations
const mutations = {
    stateFrom(state, item) {
        state.state = item
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}